<div class="w-full min-h-[20rem] flex items-center justify-center" v-if="getLoading && 0">
  <Spinner :visible="getLoading" />
</div>
<Sections @validate="onValidate" v-else :type="getCardType"></Sections>